import { createTheme } from "@mui/material";

export const THEME = createTheme({
  palette: {
    mode: "dark",
    text: {
      primary: "#fff",
    },
    primary: {
      main: "#00FB02",
      dark: "#2EAF01",
      light: "#67FB35",
    },
    secondary: {
      main: "#FFB75A",
      dark: "#B2803E",
      light: "#FFC57B",
    },
    error: {
      main: "#F44336",
      light: "#E57373",
      dark: "#D32F2F",
    },
    warning: {
      main: "#FFA726",
      dark: "#F57C00",
      light: "#FFB74D",
      contrastText: "rgba(255,255,255,0.87)",
    },
    info: {
      main: "#29B6F6",
      dark: "#0288D1",
      light: "#4FC3F7",
    },
    success: {
      main: "#66BB6A",
      dark: "#388E3C",
      light: "#81C784",
    },
    background: {
      default: "#292b2d",
      paper: "#191919",
    },
  },
  typography: {
    fontFamily: ["DM Sans", "sans-serif"].join(","),
    allVariants: {
      textTransform: "none",
    },
  },
  shape: {
    borderRadius: 10,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ ownerState }) => ({
          ...(ownerState.variant === "contained" &&
            ownerState.color === "primary" && {
              color: "#373435",
            }),
        }),
      },
    },
    MuiSelect: {
      defaultProps: {
        MenuProps: { sx: { maxHeight: "18rem" } },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: () => ({
          backgroundColor: "#191919",
          boxShadow: "none",
          padding: 0,
        }),
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: () => ({
          backgroundColor: "#191919",
          padding: 0,
        }),
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: () => ({
          backgroundColor: "#191919",
          boxShadow: "none",
        }),
      },
    },
  },
});

export const GLOBAL_STYLES = () => ({
  "*": {
    "::-webkit-scrollbar": {
      width: "0.2rem",
      height: "0.2rem",
    },
    "::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "::-webkit-scrollbar-thumb": {
      "background-color": THEME.palette.background.default,
      "border-radius": "0.2rem",
    },
    "::-webkit-scrollbar-thumb:hover": {
      "background-color": THEME.palette.background.default,
    },
  },
  "html,body,#root": {
    margin: 0,
    padding: 0,
    height: "100%",
  },
  html: {
    fontFamily: "DM Sans, sans-serif",
    color: "#fff",
    "*::selection": {
      background: THEME.palette.primary.main,
      color: THEME.palette.background.default,
    },
  },
  body: {
    backgroundColor: "#191919",
    display: "flex",
    justifyContent: "center",
  },
  "#root": {
    width: "100%",
    maxWidth: "30rem",
    padding: "0 !important",
  },
  ".background-image": {
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    overflow: "hidden",
  },
});
